import React from 'react';
import { cn } from '../../lib/utils';
import { Cube as BoxIcon } from '@phosphor-icons/react';
interface EmptyStateProps {
  icon: BoxIcon;
  title: string;
  description: string;
  action?: React.ReactNode;
  className?: string;
}
export function EmptyState({
  icon: Icon,
  title,
  description,
  action,
  className
}: EmptyStateProps) {
  return <div className={cn('flex min-h-[400px] flex-col items-center justify-center rounded-xl border border-dashed p-8 text-center animate-in fade-in-50', className)} data-id="element-2832">
      <div className="mx-auto flex max-w-[420px] flex-col items-center justify-center text-center" data-id="element-2833">
        <div className="flex h-20 w-20 items-center justify-center rounded-full bg-muted" data-id="element-2834">
          <Icon className="h-10 w-10 text-muted-foreground" data-id="element-2835" />
        </div>
        <h2 className="mt-6 text-xl font-semibold" data-id="element-2836">{title}</h2>
        <p className="mt-2 mb-8 text-center text-sm font-normal leading-6 text-muted-foreground" data-id="element-2837">
          {description}
        </p>
        {action}
      </div>
    </div>;
}